// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y9md","type":"styles_type__26e-l","choices":"styles_choices__2AzI-"};